import React, { FC } from 'react';
import { Icons } from '../../../assets/SvgIcons';
import classes from './CustomTag.module.css';

type IProps = {
  text: string | React.ReactNode;
  clickHandler?: (obj: any) => any;
  className?: string;
  color?: string;
  textColor?: string;
  borderRadius?: string;
  padding?: string;
  margin?: string;
  display?: string;
  removeItem?: () => any;
  fontSize?: number;
};

const CustomTag: FC<IProps> = ({
  text,
  clickHandler,
  className,
  color,
  textColor,
  borderRadius,
  padding,
  margin,
  display,
  removeItem,
  fontSize,
}) => {
  const classesList = [classes.CustomTag, className];
  return (
    <div
      onClick={clickHandler}
      className={classesList.join(' ')}
      style={{
        backgroundColor: color ? color : 'gray',
        borderRadius: borderRadius || '4px',
        padding: padding || '2px 4px',
        margin: margin || '0px 6px',
        display: display ? display : 'flex',
      }}
    >
      <div
        className={classes.text}
        style={{
          color: textColor ? textColor : 'black',
          fontSize: fontSize ? `${fontSize}px` : '12px',
        }}
      >
        {text}
      </div>
      {removeItem ? (
        <>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginLeft: 6,
            }}
            onClick={removeItem}
          >
            {}
            <Icons.Cancel width="12" height="12" color="#fff" />
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default CustomTag;
